import styled from '@emotion/styled';
import { theme as defaultTheme } from '../styles/theme';
import { SwitchProps } from './types';

export const InputStyle = styled('input')`
  height: 10px;
  width: 0;
  visibility: hidden;
  outline: none;
  position: absolute;
  left: 50%;
  top: 12%;
`;

export const LabelStyle = styled<'label', Pick<SwitchProps, 'checked'>>(
  'label'
)`
  cursor: pointer;
  width: 60px;
  min-width: 60px;
  height: 22px;
  display: block;
  border-radius: 100px;
  display: flex;
  align-items: center;
  position: relative;
  background-color: ${props =>
    props.checked
      ? defaultTheme.color.primary.default
      : defaultTheme.color.text.F};
  transition: 0.3s;
  outline: none;
`;

export const ThumbStyle = styled<'span', Pick<SwitchProps, 'checked'>>('span')`
  position: absolute;
  left: ${props => (props.checked ? '100%' : '0')};
  top: -1px;
  transform: ${props => props.checked && 'translateX(-99%)'};
  width: 23px;
  height: 23px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: #bdbdbd 0 1px 2px 0;
  border-radius: 90px;
  transition: 0.3s;

  &:hover {
    box-shadow: #bdbdbd 0 2px 4px 0;
  }
`;

export const CheckedNode = styled('span')`
  position: absolute;
  left: 8px;
  font-size: 14px;
  color: #fff;
  font-weight: ${defaultTheme.typography.fontWeight.normal};
`;

export const UnCheckedNode = styled('span')`
  position: absolute;
  right: 8px;
  font-size: 14px;
  color: ${defaultTheme.color.text.B3};
  font-weight: ${defaultTheme.typography.fontWeight.normal};
`;
